/* Functions for the top-info-bar */
const showMoreButton = document.querySelector( '.info-bar-content--show-more' );
const showLessButton = document.querySelector( '.info-bar-content--show-less' );

if ( showMoreButton ) {
	showMoreButton.addEventListener( 'click', function( e ) {
		e.preventDefault();
		toggleExpandInformationBar();
	} );
}

if ( showLessButton ) {
	showLessButton.addEventListener( 'click', function( e ) {
		e.preventDefault();
		toggleExpandInformationBar();
	} );
}

/**
 * Toggles the 'expanded' class on the .info-bar
 */
function toggleExpandInformationBar() {
	document.querySelector( '.info-bar' ).classList.toggle( 'expanded' );
}
